import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "m32.5 22.5 1 3-4.982 2.135a2.386 2.386 0 0 0 1.842 4.401l7.765-3.17a2 2 0 0 0 1.085-2.631L34.975 16.23a4 4 0 0 0-5.12-2.174l-2.277.876a4 4 0 0 0-2.157 5.492l1.881 3.843-5.072 1.575c-1.776.551-2.42 2.73-1.23 4.158m8.5-10.5h2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "9",
  r: "4.5",
  stroke: "#F69100"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M8.385 34.924a5 5 0 1 1 9.153.175M18 38.5a2 2 0 0 0-2-2H8.5a2 2 0 1 0 0 4H10m26.5-11H42"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "m26.5 36 .337 4.04a2 2 0 0 1-1.794 2.156l-10.989 1.099a2.116 2.116 0 0 1-.626-4.18L21.5 37.5l-.984-4.676A4 4 0 0 1 24.43 28H28M27 40.5h13"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }